/*
 * Copyright (c) 2018 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React from 'react';
import { AppConsumer } from '@keystone/common';
import { VadConsumer } from '../pages/vad/VadContext';
import { TaskConsumer } from '../pages/task/TaskContext';
import { ConfigurationConsumer } from '../pages/common/ConfigurationContext';

export function withApplicationContext(Component) {
  return (props) => (
    <AppConsumer>{(appContext) => <Component {...props} appContext={appContext} />}</AppConsumer>
  );
}

export function withVadContext(Component) {
  return (props) => (
    <VadConsumer>{(vadContext) => <Component {...props} vadContext={vadContext} />}</VadConsumer>
  );
}

export function withTaskContext(Component) {
  return (props) => (
    <TaskConsumer>
      {(taskContext) => <Component {...props} taskContext={taskContext} />}
    </TaskConsumer>
  );
}

export function withConfigurationContext(Component) {
  return (props) => (
    <ConfigurationConsumer>
      {(configurationContext) => (
        <Component {...props} configurationContext={configurationContext} />
      )}
    </ConfigurationConsumer>
  );
}

export function withAllContexts(Component) {
  return (props) => (
    <AppConsumer>
      {(appContext) => (
        <VadConsumer>
          {(vadContext) => <Component {...props} appContext={appContext} vadContext={vadContext} />}
        </VadConsumer>
      )}
    </AppConsumer>
  );
}
